// Blog articles in French — demo content for SEO
export const CATEGORIES = [
  "Anxiété",
  "Traumatisme",
  "Burn-out",
  "Sommeil",
  "Psychosomatique",
  "Relations et séparation",
];

export const POSTS = [
  {
    slug: "comprendre-anxiete-generalisee",
    title: "Comprendre l'anxiété généralisée : signaux et premiers leviers",
    category: "Anxiété",
    date: "2025-12-04",
    excerpt:
      "L'anxiété généralisée s'installe souvent en silence. Identifier ses signaux est la première étape pour s'en libérer.",
    cover:
      "https://images.unsplash.com/photo-1491929536571-bdbc57e72324?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "6 min",
    content: [
      "L'anxiété généralisée se manifeste par une inquiétude diffuse, durable, qui semble se déplacer d'un sujet à l'autre. Elle peut sembler banale et passer inaperçue pendant des années avant d'être identifiée.",
      "Parmi les signaux fréquents : tensions musculaires, troubles du sommeil, ruminations répétitives, fatigabilité, difficultés de concentration. Lorsque ces signaux deviennent persistants, ils méritent une attention spécifique.",
      "Un premier levier consiste à reconnaître que l'anxiété n'est pas un défaut de caractère mais un signal du système nerveux. Apprendre à le réguler — par la respiration, la cohérence cardiaque, la pleine conscience — ouvre déjà un espace de soulagement.",
      "Un accompagnement permet ensuite d'explorer ce qui nourrit cette anxiété : schémas relationnels, événements anciens, exigences excessives envers soi-même. Le travail peut alors devenir plus profond et plus durable.",
    ],
  },
  {
    slug: "emdr-comment-ca-fonctionne",
    title: "EMDR : comment fonctionne le retraitement d'un souvenir traumatique",
    category: "Traumatisme",
    date: "2025-11-22",
    excerpt:
      "L'EMDR mobilise des mécanismes naturels du cerveau pour intégrer ce qui est resté bloqué.",
    cover:
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "7 min",
    content: [
      "L'EMDR (Eye Movement Desensitization and Reprocessing) est une thérapie reconnue dans le traitement des psychotraumatismes. Elle est aujourd'hui recommandée par l'OMS et la Haute Autorité de Santé.",
      "Lorsqu'un événement dépasse les ressources d'adaptation, certaines informations restent figées dans la mémoire. Elles continuent alors de générer des symptômes : reviviscences, hypervigilance, évitement.",
      "L'EMDR utilise des stimulations bilatérales alternées (mouvements oculaires, tapotements, sons) pour permettre au cerveau de retraiter ces informations. Le souvenir reste, mais il perd sa charge émotionnelle envahissante.",
      "Le travail se déroule selon un protocole en huit phases, dans lequel la stabilisation et la sécurité du patient sont prioritaires. Aucun retraitement n'est entrepris sans préparation suffisante.",
    ],
  },
  {
    slug: "burn-out-signaux-precoces",
    title: "Burn-out : reconnaître les signaux précoces avant l'effondrement",
    category: "Burn-out",
    date: "2025-11-08",
    excerpt:
      "Le burn-out s'installe progressivement. Les signaux précoces permettent d'agir avant l'épuisement complet.",
    cover:
      "https://images.unsplash.com/photo-1631248055158-edec7a3c072b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "5 min",
    content: [
      "Le burn-out ne survient jamais du jour au lendemain. Il est l'aboutissement d'un déséquilibre prolongé entre les exigences perçues et les ressources disponibles.",
      "Les signaux précoces incluent : un sommeil qui ne répare plus, une difficulté à décrocher du travail, un cynisme nouveau envers ses missions ou ses collègues, une perte progressive de plaisir.",
      "Lorsque ces signaux apparaissent, un temps de pause et d'évaluation est essentiel. Un accompagnement précoce peut éviter une décompensation plus longue à traverser.",
      "Le travail thérapeutique explore les facteurs personnels (perfectionnisme, hyperdisponibilité, difficulté à dire non) et organisationnels qui ont conduit à l'épuisement, afin de construire une posture plus durable.",
    ],
  },
  {
    slug: "hygiene-du-sommeil",
    title: "L'hygiène du sommeil : repères concrets pour mieux dormir",
    category: "Sommeil",
    date: "2025-10-25",
    excerpt:
      "Le sommeil ne se commande pas. Il se prépare, par un ensemble de repères simples.",
    cover:
      "https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "5 min",
    content: [
      "Le sommeil est l'un des premiers indicateurs d'équilibre émotionnel. Lorsqu'il se dégrade, c'est souvent le signe d'un système nerveux trop sollicité.",
      "Quelques repères : maintenir des horaires de coucher et de lever réguliers, éviter les écrans dans l'heure précédant le sommeil, garder une chambre fraîche et sombre, réserver le lit au sommeil.",
      "Lorsque l'endormissement est entravé par des ruminations, la cohérence cardiaque et des pratiques de pleine conscience peuvent constituer un soutien efficace.",
      "Si les troubles persistent au-delà de quelques semaines, un accompagnement spécifique est recommandé, en lien avec votre médecin traitant si besoin.",
    ],
  },
  {
    slug: "corps-emotions-psychosomatique",
    title: "Le corps comme messager : comprendre les symptômes psychosomatiques",
    category: "Psychosomatique",
    date: "2025-10-12",
    excerpt:
      "Quand les mots manquent, le corps parle. Explorer ce lien transforme la prise en charge.",
    cover:
      "https://images.unsplash.com/photo-1448375240586-882707db888b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "6 min",
    content: [
      "La distinction entre corps et esprit, héritée d'une longue tradition, ne rend pas compte de leur intrication. Les recherches contemporaines confirment l'influence réciproque entre états émotionnels et manifestations corporelles.",
      "Les troubles psychosomatiques ne sont pas « imaginaires ». Ils sont l'expression somatique d'une dynamique émotionnelle. Les reconnaître ne signifie pas en minimiser la réalité, bien au contraire.",
      "L'accompagnement explore avec respect l'histoire personnelle, les contextes d'apparition des symptômes et les émotions difficilement exprimables. Hypnose, EFT et cohérence cardiaque peuvent y être intégrés.",
      "Cette démarche ne se substitue jamais à un suivi médical. Elle s'inscrit en complément, dans un dialogue ouvert avec les professionnels de santé concernés.",
    ],
  },
  {
    slug: "traverser-une-separation",
    title: "Traverser une séparation : étapes et ressources",
    category: "Relations et séparation",
    date: "2025-09-30",
    excerpt:
      "Une séparation est un deuil affectif. La traverser demande du temps, des appuis et parfois un accompagnement.",
    cover:
      "https://images.unsplash.com/photo-1609885728169-8737a953a103?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    readingTime: "6 min",
    content: [
      "Une séparation marque la fin d'un projet partagé, d'une organisation de vie, parfois d'une identité construite à deux. Elle mobilise une palette d'émotions souvent contradictoires.",
      "Le processus de deuil affectif suit des étapes non linéaires : sidération, colère, tristesse, négociation interne, acceptation. Chacune mérite d'être traversée sans précipitation.",
      "S'appuyer sur des ressources concrètes — entourage, activités physiques, rythme de vie soutenant — fait partie du processus. Un accompagnement professionnel peut soutenir les étapes les plus douloureuses.",
      "À distance, il est possible d'identifier ce que cette relation a apporté, ce qui a manqué, et d'en tirer une connaissance plus fine de ses besoins affectifs pour les liens futurs.",
    ],
  },
];
